import type { FC } from 'react';
import type { BadgeItem } from '@weberus/shared-types';
import type { ProductBadgeProps } from '@yanolja-rnd/nol-design-system';
import { ProductBadge } from '@yanolja-rnd/nol-design-system';

/*
 * Badge_benefit
 * 사용 영역: 국내숙소, 레저, 해외숙소
 * 타입 정보: Banner, List, Card
 */

export interface BenefitBadgeProps {
  benefitBadges?: BadgeItem[] | null;
}

/**
 * @see {@link https://yanolja.atlassian.net/wiki/spaces/~jusong.lee/pages/491947083/PLP+SRP#Enum---Badges}
 * */
const BadgeRenderer = ({ badge, size = 'medium' }: { badge: BadgeItem; size?: ProductBadgeProps['size'] }) => {
  const { type, text = '' } = badge;

  switch (type) {
    case 'BENEFIT_PRIMARY':
      return (
        <ProductBadge type="filled_secondary" size={size} className="pc:py-0">
          {text}
        </ProductBadge>
      );
    case 'BENEFIT_INFO':
    default:
      return (
        <ProductBadge type="filled_basic" size={size} className="pc:py-0">
          {text}
        </ProductBadge>
      );
  }
};

export const UnitBenefitBadge: FC<BenefitBadgeProps> = ({ benefitBadges }) => {
  if (!benefitBadges) return null;

  return (
    <div className="flex shrink-0 flex-wrap items-center justify-start gap-4 py-2">
      {benefitBadges.map((badge, idx) => (
        <BadgeRenderer key={idx} badge={badge} size="medium" />
      ))}
    </div>
  );
};

export const UnitCardBenefitBadge: FC<BenefitBadgeProps> = ({ benefitBadges }) => {
  if (!benefitBadges) return null;

  return (
    <div className="mb-4 mt-2 flex shrink-0 flex-wrap items-center justify-start gap-4">
      {benefitBadges.map((badge, idx) => (
        <BadgeRenderer key={idx} badge={badge} size="small" />
      ))}
    </div>
  );
};
